import React from 'react';
import SimpleDashboard from './components/SimpleDashboard';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 relative">
        <SimpleDashboard />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;